export function createAct<T>(type: string) {
  return function innerActCreator(payload: T) {
    return {
      type,
      payload,
    };
  };
}
